import type { CopyCatalog } from "./copyTypes";

export const DE_COPY: CopyCatalog = {
  "common.loading": "Laden…",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.notProvided": "Nicht angegeben",
  "common.notRequired": "Nicht erforderlich",
  "common.requested": "Angefragt",
  "nav.back": "Zurück",
  "nav.continue": "Weiter",
  "nav.sendRequest": "Anfrage senden",
  "nav.sending": "Senden…",
  "alert.completeFields": "Bitte füllen Sie die markierten Felder aus, bevor Sie fortfahren.",
  "fill.filled": "Ausgefüllt",
  "fill.notFound": "Nicht gefunden",
  "fill.shipmentToo": "Sendung ebenfalls ausgefüllt: {detail}",
  "fill.palletMany": "Paletten",

  "choose.title": "Wie möchten Sie Ihr Angebot anfragen?",
  "choose.manual.title": "Manuelle Eingabe",
  "choose.manual.description": "Geben Sie Ihre Sendungsdaten Schritt für Schritt über das Formular ein.",
  "choose.manual.action": "Daten manuell eingeben",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Fügen Sie die Sendungsdaten ein oder laden Sie ein Dokument hoch, dann füllen wir das Formular für Sie aus.",
  "choose.quickfill.action": "Schnellausfüllung starten",

  "steps.route": "Route & Auftrag",
  "steps.shipment": "Sendung",
  "steps.services": "Zusätzliche Leistungen",
  "steps.contact": "Kontakt",
  "steps.review": "Prüfen",

  "page.route": "Route und Auftrag",
  "page.routeSection": "Route",
  "page.shipment": "Sendungsdaten",
  "page.services": "Zusätzliche Leistungen",
  "page.contact": "Kontaktdaten",
  "page.contactSection": "Ihre Kontaktdaten",
  "page.review": "Prüfen",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Ihr Dokument wird analysiert",

  "route.hintPostcode": "Geben Sie eine Postleitzahl oder einen Ort für Verladung und Entladung ein.",
  "route.hintFullAddress": "Geben Sie die vollständige Verlade- und Entladeadresse ein.",
  "route.unsupported": "Diese Route wird nicht unterstützt. Verwenden Sie das Formular für {loadCountry} und {unloadCountry}.",
  "route.loading": "Verladung",
  "route.unloading": "Entladung",
  "route.origin": "Herkunft",
  "route.destination": "Ziel",
  "route.country": "Land",
  "route.selectCountry": "Land auswählen",
  "route.postcode": "Postleitzahl",
  "route.postcodePlaceholder": "z. B. 10115",
  "route.city": "Ort",
  "route.cityPlaceholder": "Ort eingeben",
  "route.street": "Straßenname",
  "route.streetPlaceholder": "Straße eingeben",
  "route.house": "Hausnummer",
  "route.housePlaceholder": "z. B. 12",
  "route.pickupDate": "Gewünschtes Abholdatum:",
  "route.unloadDate": "Gewünschtes Entladedatum:",
  "route.datePlaceholder": "tt.mm.jjjj",
  "date.clear": "Datum löschen",
  "date.closeCalendar": "Kalender schließen",
  "date.openCalendar": "Kalender öffnen",
  "route.specificDateHint":
    "Für Waren, die an einem bestimmten Datum bereitstehen. Andernfalls streben wir die schnellste Option an.",
  "route.orderDetails": "Auftragsdaten",

  "shipment.goods": "Warenbeschreibung",
  "shipment.goodsPlaceholder": "Was möchten Sie transportieren?",
  "shipment.weight": "Gesamtgewicht",
  "shipment.qty": "Menge",
  "shipment.type": "Typ",
  "shipment.dims": "Abmessungen / LDM",
  "shipment.stackable": "Stapelbar",
  "shipment.addRow": "Sendungszeile hinzufügen",
  "shipment.totalLines": "Anzahl der Zeilen: {count}",
  "shipment.selectDims": "Abmessungen auswählen",
  "shipment.dimsNa": "Abmessungen nicht zutreffend",
  "shipment.sizeModeDims": "L × B × H",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Sendungszeile {n} entfernen",
  "shipment.lineLabel": "{text}, Zeile {n}",
  "shipment.quantity": "Menge",
  "qty.decrease": "Menge verringern",
  "qty.increase": "Menge erhöhen",
  "shipment.lengthCm": "Länge (cm)",
  "shipment.widthCm": "Breite (cm)",
  "shipment.heightCm": "Höhe (cm)",
  "shipment.dimensions": "Abmessungen",
  "shipment.size": "Größe",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Halbpalette",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Sondermaß",
  "pallet.unspecified": "LDM",

  "services.aria": "Zusätzliche Leistungen",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Temperatur",
  "services.pill.tail": "Ladebordwand",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Zeitfenster",
  "services.pill.ref": "Referenz / Hinweise",
  "services.pill.references": "Referenzen",
  "services.pill.attachments": "Weitere Anhänge",
  "services.adrClass": "ADR-Klasse",
  "services.selectClass": "Klasse auswählen",
  "services.unNumber": "UN-Nummer",
  "services.unPlaceholder": "z. B. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Ladebordwand beim Laden",
  "services.tailUnload": "Ladebordwand beim Entladen",
  "services.ftlCopy": "Komplettladung angefragt.",
  "services.invoiceRef": "Rechnungsreferenz",
  "services.reference": "Referenz",
  "services.loadingRef": "Verladereferenz",
  "services.unloadingRef": "Entladereferenz",
  "services.notes": "Hinweise",
  "services.notesPlaceholder": "z. B. besondere Anweisungen",
  "services.deadline": "Gewünschte Lieferfrist:",
  "services.deliveryHint":
    "Für Waren, die an einem bestimmten Datum geliefert werden müssen. Andernfalls streben wir die schnellste Option an.",
  "services.loadingTime": "Verladezeit",
  "services.unloadingTime": "Entladezeit",
  "services.window": "Zeitfenster",
  "services.fixed": "Fest",
  "services.at": "um",
  "services.from": "von",
  "services.to": "bis",
  "services.timeTypeAria": "{title} Typ",
  "services.addFiles": "Dateien hinzufügen",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP oder PDF. Bis zu {maxFiles} Dateien, {maxFileMb} MB je Datei, {maxTotalMb} MB insgesamt.",
  "services.adrClass1": "1 Explosive Stoffe",
  "services.adrClass2": "2 Gase",
  "services.adrClass3": "3 Entzündbare flüssige Stoffe",
  "services.adrClass4": "4 Entzündbare feste Stoffe",
  "services.adrClass5": "5 Entzündend wirkende Stoffe",
  "services.adrClass6": "6 Giftige / ansteckungsgefährliche Stoffe",
  "services.adrClass7": "7 Radioaktive Stoffe",
  "services.adrClass8": "8 Ätzende Stoffe",
  "services.adrClass9": "9 Verschiedene gefährliche Stoffe",
  "services.summary.adr": "Gefahrgut (ADR)",
  "services.summary.temp": "Temperaturgeführt",
  "services.summary.time": "Zeitfenster",
  "services.summary.refNotes": "Referenz und Hinweise",
  "services.summary.tail": "Ladebordwand",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Weitere Anhänge",
  "services.tail.loadUnload": "Verladung und Entladung",
  "services.tail.loadOnly": "Nur Verladung",
  "services.tail.unloadOnly": "Nur Entladung",
  "services.time.load": "Verladung: {value}",
  "services.time.unload": "Entladung: {value}",
  "services.time.deadline": "Frist: {value}",
  "services.time.fixedSuffix": "{time} (fest)",
  "services.time.windowRange": "{from} bis {until}",
  "services.adr.yes": "Ja",
  "services.adr.classUn": "Klasse {class}, UN {un}",
  "services.adr.classOnly": "Klasse {class}",
  "services.adr.unOnly": "UN {un}",
  "services.temp.range": "{min}°C bis {max}°C",
  "services.ref.invoice": "Rechnung: {value}",
  "services.ref.loading": "Verladung: {value}",
  "services.ref.unloading": "Entladung: {value}",

  "contact.name": "Name",
  "contact.company": "Unternehmen",
  "contact.email": "E-Mail",
  "contact.phone": "Telefon",
  "contact.comment": "Zusätzlicher Kommentar",
  "contact.privacyBefore":
    "Ich stimme der Verarbeitung meiner personenbezogenen Daten gemäß der ",
  "contact.privacyLink": "Datenschutzerklärung",
  "contact.privacyAfter": " von Neele-Vat zu.",

  "result.thankYou": "Vielen Dank! Ihre Anfrage ist eingegangen.",
  "result.teamWillContact":
    "Unser Team wird Sie innerhalb von 60 Minuten während der Geschäftszeiten kontaktieren.",
  "result.teamWillContactEmail":
    "Unser Team wird Sie innerhalb von 60 Minuten während der Geschäftszeiten unter {email} kontaktieren.",
  "result.previewMode": "Vorschaumodus — diese Anfrage wurde nicht wirklich gesendet.",
  "result.previewFiles": " Hinweis: Dateien können im Vorschaumodus nicht gesendet werden.",
  "result.yourReference": "Ihre Referenz",
  "result.copy": "Kopieren",
  "result.copied": "Kopiert",
  "result.nextTitle": "Wie es weitergeht",
  "result.next1": "Anfrage eingegangen.",
  "result.next2": "Anfrage wird geprüft.",
  "result.next3": "Antwort innerhalb von 60 Minuten per E-Mail.",
  "result.logged":
    "Wir haben Ihre Anfrage erfasst. Wenn Sie nichts von uns hören, kontaktieren Sie uns bitte über die Angaben unten.",
  "result.newQuote": "Neues Angebot starten",
  "result.sendFailed": "Wir konnten Ihre Anfrage nicht senden",
  "result.preferDirect": "Lieber direkt Kontakt aufnehmen?",
  "result.backToEdit": "Zurück zur Bearbeitung",
  "result.tryAgain": "Erneut versuchen",
  "result.hideDetails": "Details ausblenden",
  "result.viewSent": "Gesendete Daten anzeigen",
  "result.error.rateLimited":
    "Sie haben in kurzer Zeit viele Anfragen gestellt. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
  "result.error.forbidden":
    "Diese Anfrage wurde blockiert. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.",
  "result.error.network":
    "Wir konnten Ihre Anfrage gerade nicht senden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "result.error.tooLarge":
    "Diese Anfrage ist zu groß zum Senden. Verwenden Sie kleinere Anhänge oder einen kürzeren Kommentar.",
  "result.error.unsupportedType": "Verwenden Sie nur JPEG, PNG, GIF, WebP oder PDF.",
  "result.error.emailUnavailable":
    "Wir konnten Ihre Anfrage mit den Anhängen nicht per E-Mail senden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.",

  "qf.hint":
    "Fügen Sie eine E-Mail oder Sendungsdaten ein oder hängen Sie ein Bild oder PDF an. Dadurch werden bereits eingegebene Daten ersetzt.",
  "qf.placeholder":
    "z. B. 24 Europaletten von 3011 Rotterdam nach 20095 Hamburg, 12.000 kg, Abholung morgen…",
  "qf.ariaPaste": "Zu analysierende Sendungsdaten",
  "qf.attach": "Bild oder PDF anhängen",
  "qf.disclaimer":
    "Alles, was Sie einfügen oder anhängen, wird nur zum Ausfüllen dieser Anfrage verwendet. Es wird von unserer Dokumentanalyse verarbeitet und nach dem Ausfüllen des Formulars nicht gespeichert.",
  "qf.fillForm": "Formular ausfüllen",
  "qf.working": "Wird verarbeitet…",
  "qf.analyzing": "Ihre Daten werden analysiert…",
  "qf.noFields": "Es konnten keine Felder erkannt werden. Bitte fügen Sie mehr Details hinzu.",
  "qf.rateLimited": "Sie haben zu viele Anfragen gestellt. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
  "qf.blocked": "Diese Anfrage wurde blockiert. Bitte kontaktieren Sie uns, falls das unerwartet ist.",
  "qf.extractUnavailable":
    "Die Dokumentanalyse ist derzeit nicht verfügbar. Fügen Sie die Sendungsdaten stattdessen ein.",
  "qf.genericError": "Etwas ist schiefgelaufen. Bitte prüfen Sie Ihr Netzwerk oder versuchen Sie es erneut.",
  "qf.analyzeTitle": "Ihr Dokument wird analysiert...",
  "qf.analyzeSub": "Das dauert in der Regel ein paar Sekunden",
  "qf.analyzeStep1": "Dokumentstruktur lesen",
  "qf.analyzeStep2": "Grunddaten extrahieren",
  "qf.analyzeStep3": "Sendungszeilen erkennen",
  "qf.removeFile": "{name} entfernen",

  "error.loadCountry": "Wählen Sie ein Verladeland.",
  "error.loadPostal": "Geben Sie die Postleitzahl der Verladung ein.",
  "error.loadCity": "Geben Sie den Verladeort ein.",
  "error.loadStreet": "Geben Sie den Straßennamen der Verladung ein.",
  "error.loadHouseNumber": "Geben Sie die Hausnummer der Verladung ein.",
  "error.unloadCountry": "Wählen Sie ein Entladeland.",
  "error.unloadPostal": "Geben Sie die Postleitzahl der Entladung ein.",
  "error.unloadCity": "Geben Sie den Entladeort ein.",
  "error.unloadStreet": "Geben Sie den Straßennamen der Entladung ein.",
  "error.unloadHouseNumber": "Geben Sie die Hausnummer der Entladung ein.",
  "error.pickupDate": "Wählen Sie ein Abholdatum.",
  "error.unloadDate": "Wählen Sie ein Entladedatum.",
  "error.invalidDate": "Bitte geben Sie ein gültiges Datum ein.",
  "error.totalWeight": "Geben Sie das Gesamtgewicht ein.",
  "error.goods": "Beschreiben Sie die Waren.",
  "error.loadCityOrPostal": "Geben Sie die Postleitzahl oder den Ort der Verladung ein.",
  "error.unloadCityOrPostal": "Geben Sie die Postleitzahl oder den Ort der Entladung ein.",
  "error.loadPostalInvalid": "Geben Sie eine gültige Postleitzahl der Verladung ein.",
  "error.loadCityInvalid": "Geben Sie einen gültigen Ort der Verladung ein.",
  "error.unloadPostalInvalid": "Geben Sie eine gültige Postleitzahl der Entladung ein.",
  "error.unloadCityInvalid": "Geben Sie einen gültigen Ort der Entladung ein.",
  "error.pickupPast": "Das Abholdatum darf nicht in der Vergangenheit liegen.",
  "error.unloadPast": "Das Entladedatum darf nicht in der Vergangenheit liegen.",
  "error.unloadBeforePickup": "Das Entladedatum darf nicht vor dem Abholdatum liegen.",
  "error.weightRange": "Geben Sie ein Gewicht zwischen 1 und {max} kg ein.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Geben Sie die 4-stellige UN-Nummer ein.",
  "error.invoiceRef": "Geben Sie die Rechnungsreferenz ein.",
  "error.loadingRef": "Geben Sie die Verladereferenz ein.",
  "error.unloadingRef": "Geben Sie die Entladereferenz ein.",
  "error.tempMin": "Geben Sie die Mindesttemperatur ein.",
  "error.tempMax": "Geben Sie die Höchsttemperatur ein.",
  "error.tempOrder": "Max muss mindestens Min sein.",
  "error.enterNumber": "Geben Sie eine Zahl ein.",
  "error.deliveryPast": "Die Lieferfrist darf nicht in der Vergangenheit liegen.",
  "error.deliveryBeforePickup": "Die Lieferfrist darf nicht vor dem Abholdatum liegen.",
  "error.tailSides": "Wählen Sie Verladung, Entladung oder beides.",
  "error.attachOne": "Hängen Sie mindestens eine Datei an.",
  "error.enterTime": "Geben Sie eine Uhrzeit ein.",
  "error.enterStartTime": "Geben Sie eine Startzeit ein.",
  "error.enterEndTime": "Geben Sie eine Endzeit ein.",
  "error.enterMinutes": "Geben Sie die Minuten ein.",
  "error.completeTime": "Geben Sie eine vollständige Uhrzeit ein.",
  "error.enterEmail": "Geben Sie Ihre E-Mail-Adresse ein.",
  "error.validEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
  "error.validPhone": "Geben Sie eine gültige Telefonnummer ein.",
  "error.personalEmail": "Private E-Mail-Adressen werden nicht akzeptiert.",
  "error.enterName": "Geben Sie Ihren Namen ein.",
  "error.enterCompany": "Geben Sie Ihr Unternehmen ein.",
  "error.privacy": "Bitte stimmen Sie zu, um fortzufahren.",
  "error.quickFillEmpty":
    "Fügen Sie Sendungsdaten ein oder hängen Sie ein Bild oder PDF an, um das Formular auszufüllen.",
  "error.maxFiles": "Sie können bis zu {max} Dateien anhängen.",
  "error.maxFileMb": "Jede Datei darf höchstens {max} MB groß sein.",
  "error.maxTotalMb": "Anhänge dürfen insgesamt höchstens {max} MB groß sein.",
  "error.filesSkippedType": "Einige Dateien wurden übersprungen. Verwenden Sie JPEG, PNG, GIF, WebP oder PDF.",
  "error.emptySkipped": "Leere Dateien wurden übersprungen.",
  "error.fileEmpty": "Die ausgewählte Datei ist leer.",
  "error.filesEmptyOrType": "Einige Dateien waren leer oder kein JPEG, PNG, GIF, WebP oder PDF.",
  "error.attachType": "Hängen Sie ein JPEG, PNG, GIF, WebP oder PDF an.",
  "error.subjectLong": "Der Betreff ist zu lang.",
  "error.emailTextLong": "Die Anfragedaten sind zu lang.",
  "error.shortenSubject": "Kürzen Sie diesen Wert, damit der E-Mail-Betreff innerhalb von {max} Zeichen bleibt.",
  "error.shortenBody":
    "Kürzen Sie die Sendungsdaten oder den Kommentar, damit die E-Mail innerhalb von {max} Zeichen bleibt.",

  "announce.choose": "Wählen Sie, wie Sie Ihr Angebot anfragen möchten",
  "announce.quickfill": "Schnellausfüllung: Daten einfügen oder Dokument hochladen",
  "announce.route": "Schritt 1 von 5: Route und Auftrag",
  "announce.shipment": "Schritt 2 von 5: Sendungsdaten",
  "announce.services": "Schritt 3 von 5: zusätzliche Leistungen",
  "announce.contact": "Schritt 4 von 5: Kontaktdaten",
  "announce.review": "Schritt 5 von 5: prüfen Sie Ihre Anfrage",
  "announce.received": "Anfrage eingegangen",
  "announce.sendFailed": "Wir konnten Ihre Anfrage nicht senden",
  "announce.sendFailedAttempt": "Wir konnten Ihre Anfrage nicht senden (Versuch {n})",
  "announce.completeFields": "Bitte füllen Sie die markierten Felder aus, bevor Sie fortfahren.",
  "announce.sending": "Ihre Anfrage wird gesendet…",
};
